/**
 * Created by nguyenlet on 11/11/2016.
 */
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { AppConstants } from '../constants/constants';
import { Utility } from '../../common/utility';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BaseService } from './base.service';

@Injectable()
export class SharedService {
  globalVar: string;
  globalVarUpdate: Observable<string>;
  globalVarObserver: Observer<any>;
  private menuActionSubject = new Subject<any>();
  private userUpdateSubject = new Subject<any>();
  private centreUpdateSubject = new Subject<any>();
  private dataEntryUpdateSubject = new Subject<any>();
  constructor(public baseService: BaseService) {
    this.globalVarUpdate = Observable.create((observer: Observer<any>) => {
      this.globalVarObserver = observer;
    });
  }

  updateGlobalVar(newValue: string) {
    this.globalVar = newValue;
    this.globalVarObserver.next(this.globalVar);
  }
  showReport(reportName: string, data: any) {
    this.baseService.authenticateReportSite(environment.reportServer, environment.authConfig.clientId)
      .subscribe(
        (result) => {
          if (result) {
            this.displayReport(result.json().TokenKeyId, reportName, data);
          }
        }
      );
  }
  displayReport(reportTokenId: string, reportName: string, data: any) {
    let params = '&=';
    if (data) {
      for (const key in data) {
        if (data[key] != null && data[key] != undefined && data[key] != NaN && data.hasOwnProperty(key)) {
          if (data[key] instanceof Array) {
            let paramArray = data[key];
            for (const item in paramArray) {
              if (data[key] != null && data[key] != undefined && data[key] != NaN && data.hasOwnProperty(key)) {
                const strParams = paramArray[item].toString();
                params += '&' + key + '=' + strParams;
              }
            }
          } else {
            let strParams = data[key].toString();
            params += '&' + key + '=' + strParams;
          }
        }
      }
    }

    const host = environment.reportServer + '/Reports/ReportViewer';
    const timezoneOffset = new Date().getTimezoneOffset();
    const centreId = localStorage.getItem(AppConstants.localStorage.centreId);
    const userName = localStorage.getItem(AppConstants.localStorage.deUserName) && localStorage.getItem(AppConstants.localStorage.deUserName) !== 'null'  ? localStorage.getItem(AppConstants.localStorage.deUserName): localStorage.getItem(AppConstants.localStorage.userName);

    let path = host + '?' + AppConstants.reportParameter.reportName + '={0}&' +
      AppConstants.reportParameter.reportTokenId + '={1}&' +
      AppConstants.reportParameter.clinicId + '={2}&' +
      AppConstants.reportParameter.timezoneOffset + '={3}&' +
      AppConstants.reportParameter.printedBy + '={4}';
    path = Utility.stringFormat(path, [reportName, reportTokenId, centreId, timezoneOffset, userName]);

    path += params;

    window.open(path, '_blank', 'location=yes');
  }


  /**
   * diapatch event when user toggle menu
   */
  announceMenuToggle() {
    this.menuActionSubject.next();
  }

  /**
  * get action when user toggle menu
  */
  getMenuToggle(): Observable<any> {
    return this.menuActionSubject.asObservable();
  }

  /**
   * diapatch event when current user change their infomation
   * @param data : user info data
   */
  announceUserInfoUpdate(data: any) {
    this.userUpdateSubject.next(data);
  }

  /**
  * get current user new info
  */
  getUserInfoUpdate(): Observable<any> {
    return this.userUpdateSubject.asObservable();
  }

  /**
   * diapatch event when current centre change infomation
   * @param data : centre info data
   */
  announceCentreInfoUpdate(data: any) {
    this.centreUpdateSubject.next(data);
  }

  /**
  * get current centre new info
  */
  getCentreInfoUpdate(): Observable<any> {
    return this.centreUpdateSubject.asObservable();
  }

  /**
   * diapatch event when data entry mode is changed
   * @param data : entry mode
   */
  announceDataEntryUpdate(data: any) {
    this.dataEntryUpdateSubject.next(data);
  }

  /**
  * get data entry mode
  */
  getDataEntryUpdate(): Observable<any> {
    return this.dataEntryUpdateSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/share.services.ts